module.exports = __webpack_public_path__ + "components/flag/static/square/pe-cffd5f7df77e20d7306f4c0b76f5f885.svg";